import * as React from 'react'
import type { ReactNode } from 'react'

import { useData } from './hooks'
import { ActivitySummaryContext } from './context'

type Props = {
  children: ReactNode
}

export function ActivitySummaryContextProvider(props: Props) {
  const { children } = props

  const { value } = useData()

  return (
    <ActivitySummaryContext.Provider value={value}>
      {children}
    </ActivitySummaryContext.Provider>
  )
}
